import { modelServicePost } from './modelService';

/**
 * Generates a title for a chat conversation using Gemini via model service
 *
 * @param {Object} params - Parameters for title generation
 * @param {string} params.userMessage - The first user message in the conversation
 * @param {string} params.aiResponse - The first AI response in the conversation
 * @param {string} [params.chatType='standard'] - The type of chat ('standard' or 'advanced')
 * @returns {Promise<string>} - A generated title for the conversation
 */
export const generateChatTitle = async ({ userMessage, aiResponse, chatType = 'standard' }) => {
  try {
    // Make request to our secure model service
    const response = await modelServicePost('/generate-title', {
      user_message: userMessage,
      ai_response: aiResponse,
      chat_type: chatType
    });

    if (!response.ok) {
      throw new Error(`Model service error: ${response.statusText}`);
    }

    const data = await response.json();
    return data.title || fallbackTitleGeneration(userMessage, chatType);
    
  } catch (error) {
    console.error('Error generating chat title:', error);
    // Fall back to simple truncation if API call fails
    return fallbackTitleGeneration(userMessage, chatType);
  }
};

/**
 * Fallback method for generating a title by truncating the user message
 * 
 * @param {string} userMessage - The user message to use for title generation
 * @param {string} chatType - The type of chat ('standard' or 'advanced')
 * @returns {string} - A basic title
 */
const fallbackTitleGeneration = (userMessage, chatType) => {
  // Generate a simple title from the first 40 characters of the user message
  let title = userMessage.substring(0, 40);
  if (userMessage.length > 40) title += '...';
  return title;
};

export default generateChatTitle;